import { ProjectUser } from '../../../../../../TemporaryConmonents/AddProject/types/types';
import { useDispatch, useSelector } from 'react-redux';
import { deleteProjectUser } from '../../../../../../store/slices/dashboardSlice/action';
import { managersSelector } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';

export const usePeopleCard = (user: ProjectUser) => {
    const dispatch = useDispatch();
    const managers = useSelector(managersSelector.selectAll);
    //@ts-ignore
    const { is_customer, can_show_financial_info } = useSelector((state) => state.dashboardReducer);
    const onDeleteEmployer = () => {
        dispatch(deleteProjectUser({ id: `${user.id}`, role: user.role }));
    };
    const showDeleteButton = !is_customer && can_show_financial_info;
    return {
        onDeleteEmployer,
        managers,
        showDeleteButton,
    };
};
